"use strict";const amplitude=require("amplitude-js");var main={install:(e,{apiKey:t,userId:i,config:a})=>{amplitude.getInstance().init(t,i,a),e.prototype.$amplitude=amplitude}};module.exports=main;
